import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import SignInForm from './SignInForm';
import '../assets/styles/SignInPage.css';

const SignInPage = () => (
  <Container className="sign-in-page">
    <Row className="align-items-center">
      <Col md={6} className="left-side">
        <h2>Welcome Back!</h2>
        <p>Sign in to your account and continue enjoying our services.</p>
        <img
          src="https://via.placeholder.com/400x300"
          alt="Welcome"
          className="img-fluid"
        />
      </Col>
      <Col md={6} className="right-side">
        <SignInForm
          onOtpSent={(mobile) => console.log('OTP sent to:', mobile)}
          onSignIn={(data) => console.log('Sign in with:', data)}
        />
      </Col>
    </Row>
  </Container>
);

export default SignInPage;
